import * as Sentry from '@sentry/browser'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined

if (dsn) {
    Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
    })
    Sentry.setTag('surface', 'site')
}
